export const IMAGES = {
  portrait:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_df103b22-32f3-481c-a052-2bec3842fc79/artifacts/7hxjgdy8_IMG_2353_MP.jpg",
  community:
    "https://images.unsplash.com/photo-1697490251788-21888514f669?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjBlbmdhZ2VtZW50JTIwZGl2ZXJzZSUyMGdyb3VwJTIwbGlzdGVuaW5nfGVufDB8fHx8MTc4ODQ2MjE4NXww&ixlib=rb-4.1.0&q=85",
  classroom:
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwZWxlbWVudGFyeSUyMHNjaG9vbCUyMGNoaWxkcmVuJTIwY2xhc3Nyb29tfGVufDB8fHx8MTc4ODQ2MjE4NXww&ixlib=rb-4.1.0&q=85",
  yorkRegion:
    "https://images.unsplash.com/photo-1748444146081-d141d1034fcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjYW5hZGlhbiUyMHN1YnVyYmFuJTIwbmVpZ2hib3Job29kJTIwc3RyZWV0JTIwdHJlZXN8ZW58MHx8fHwxNzg4NDYyMTg1fDA&ixlib=rb-4.1.0&q=85",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
